<template>
  <div @click="toggleValue" :class="{ 'cursor-default': disabled }">
    <div
      :class="{
        'bg-gray-300': disabled
      }"
      class="
        flex bg-gray-200 w-max rounded-full
        cursor-pointer text-gray-800 hover:bg-gray-300">
        <div
          class="
            flex justify-center items-center
            px-8 py-3 rounded-full"
          :class="{
            'bg-lula-gradient text-white': modelValue === true
          }">
          <span>
            {{ leftLabel }}
          </span>
        </div>
      <div
        class="
          flex justify-center items-center px-8 py-3
          rounded-full"
        :class="{
          'bg-lula-gradient text-white': modelValue === false
        }">
        <span>
          {{ rightLabel }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    leftLabel: {
      type: String,
      default: 'Yes',
    },
    rightLabel: {
      type: String,
      default: 'No',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    toggleValue() {
      if (this.disabled) {
        return;
      }
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
</script>
